/**
 * @generated SignedSource<<a8bd7c1e35460c9ccc3e538dcdb4b9fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CheckoutSubmitButton_transaction$data = {
  readonly buyerChargeCurrency: Currency | null;
  readonly isGiftEligible: boolean | null;
  readonly item: {
    readonly serviceId: string | null;
  } | null;
  readonly mostRecentBuyerOffer: {
    readonly serviceId: string | null;
  } | null;
  readonly mostRecentOffer: {
    readonly amountPerItem: {
      readonly convertedAmountList: ReadonlyArray<{
        readonly amount: number | null;
        readonly currency: Currency | null;
      } | null> | null;
    } | null;
  } | null;
  readonly serviceId: string | null;
  readonly skuId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutNeedsToAcknowledgeRestrictions_transaction" | "applePayCheckout_transaction" | "checkoutSubmitActions_transaction" | "useUpdateShipmentQuote_transaction">;
  readonly " $fragmentType": "CheckoutSubmitButton_transaction";
};
export type CheckoutSubmitButton_transaction$key = {
  readonly " $data"?: CheckoutSubmitButton_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSubmitButton_transaction">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Invoice",
  "kind": "LinkedField",
  "name": "buyerInvoice",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "totalAmount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ConvertedAmountList",
          "kind": "LinkedField",
          "name": "convertedAmountList",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "buyerChargeCurrency",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSubmitButton_transaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutNeedsToAcknowledgeRestrictions_transaction"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "checkoutSubmitActions_transaction",
      "selections": [
        (v2/*: any*/)
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "applePayCheckout_transaction",
      "selections": [
        (v3/*: any*/),
        (v2/*: any*/)
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useUpdateShipmentQuote_transaction"
    },
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "skuId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Item",
      "kind": "LinkedField",
      "name": "item",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    },
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Offer",
      "kind": "LinkedField",
      "name": "mostRecentBuyerOffer",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Offer",
      "kind": "LinkedField",
      "name": "mostRecentOffer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "kind": "LinkedField",
          "name": "amountPerItem",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ConvertedAmountList",
              "kind": "LinkedField",
              "name": "convertedAmountList",
              "plural": true,
              "selections": [
                (v1/*: any*/),
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGiftEligible",
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};
})();

(node as any).hash = "ea3683904d4bfadd07b5c39d8c945c67";

export default node;
